import { FieldStackedLabel } from '../../Field'
import { FormFieldsContainer } from '../../Form'
import { DocFlowScopeBuildingGroupsField } from '../DocFlowScopeBuildingGroupsField'
import { DocFlowScopeBuildingsField } from '../DocFlowScopeBuildingsField'

function DocFlowEditBuildingScopeFields() {
  return (
    <FormFieldsContainer>
      <DocFlowScopeBuildingGroupsField Field={FieldStackedLabel} />
      <DocFlowScopeBuildingsField Field={FieldStackedLabel} />
    </FormFieldsContainer>
  )
}

export default DocFlowEditBuildingScopeFields
